<template>
  <div>
    <viewTable
      ref="viewTable"
      :columns-property="columnsProperty"
      :filter="filter"
      module="basic"
      url="stockDetails/kingdee"
      :table-select="false"
      @reset="resetHandle"
    >
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="$refs.viewTable.loadData(1)">
          <el-form-item label="物料名称">
            <el-input v-model.trim="filter.materialName" placeholder="请输入物料名称" clearable />
          </el-form-item>
          <el-form-item label="物料编号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入物料编号" clearable />
          </el-form-item>
          <el-form-item label="仓库名称">
            <el-input v-model.trim="filter.warehouseName" placeholder="请输入仓库名称" clearable />
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
  </div>
</template>

<script>
import viewTable from "@/components/ViewTable.vue";
export default {
  components: { viewTable },
  data() {
    return {
      filter: {
        materialNo: "",
        materialName: "",
        warehouseName: "",
      },
      columnsProperty: [
        {
          tooltip: true,
          key: "ownerName",
          width: 240,
          align: "center",
        },
        {
          tooltip: true,
          key: "materialNo",
          width: 100,
          align: "center",
        },
        {
          key: "materialName",
          minWidth: 280,
          tooltip: true,
        },
        {
          key: "specification",
          minWidth: 220,
          tooltip: true,
        },
        {
          tooltip: true,
          key: "baseQuantity",
          width: 100,
          align: "center",
        },
        {
          tooltip: true,
          key: "warehouseNo",
          width: 100,
          align: "center",
        },
        {
          key: "warehouseName",
          width: 120,
          tooltip: true,
        },
        {
          key: "locationNo",
          width: 240,
          tooltip: true,
        },
        {
          key: "locationName",
          width: 120,
          tooltip: true,
        },
        {
          tooltip: true,
          key: "materialHeight",
          width: 100,
          align: "center",
        },
        {
          tooltip: true,
          key: "materialWidth",
          width: 90,
          align: "center",
        },
        {
          tooltip: true,
          key: "materialLength",
          width: 90,
          align: "center",
        },
        {
          tooltip: true,
          key: "materialWeight",
          width: 90,
          align: "center",
        },
        {
          tooltip: true,
          key: "unitName",
          width: 80,
          align: "center",
        },
      ],
    };
  },
  methods: {
    // 重置
    resetHandle(filter) {
      this.filter = Object.assign(this.filter, filter);
    },
  },
};
</script>
